(function () {
  'use strict';
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

  function ready(image) {
    if (image.complete && image.naturalWidth > 0) return Promise.resolve(true);
    if (image._piReady) return image._piReady;
    image._piReady = new Promise(function (resolve) {
      image.addEventListener('load', function () { resolve(image.naturalWidth > 0); }, { once: true });
      image.addEventListener('error', function () { resolve(false); }, { once: true });
      var source = image.getAttribute('data-pi-lazy') || image.getAttribute('data-pi-hover-src');
      if (source && !image.getAttribute('src')) image.setAttribute('src', source);
    });
    return image._piReady;
  }

  function show(box, index) {
    var slides = box.querySelectorAll('.PICarousel__Slide');
    if (!slides.length) return;
    index = ((index % slides.length) + slides.length) % slides.length;
    var request = (box._piRequest || 0) + 1;
    box._piRequest = request;
    box.setAttribute('data-requested', index);
    ready(slides[index]).then(function (loaded) {
      if (!loaded || box._piRequest !== request) return;
      slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === index); });
      box.classList.add('is-hover-suppressed');
      box.setAttribute('data-current', index);
      box.removeAttribute('data-requested');
    });
  }

  function loadHover(box) {
    var image = box.querySelector('[data-pi-hover-src]');
    if (!image) return;
    ready(image).then(function (loaded) { box.classList.toggle('is-hover-ready', loaded); });
  }

  function boxFrom(target) {
    var card = target && target.closest ? target.closest('.ProductItem') : null;
    return card ? card.querySelector('[data-pi-carousel]') : null;
  }

  function enter(event) {
    if (!finePointer.matches || event.pointerType === 'touch') return;
    var box = boxFrom(event.target);
    if (!box) return;
    var card = box.closest('.ProductItem');
    if (event.relatedTarget && card.contains(event.relatedTarget)) return;
    box.classList.add('is-hovering');
    box.classList.remove('is-hover-suppressed');
    loadHover(box);
  }

  function leave(event) {
    var box = boxFrom(event.target);
    if (!box) return;
    var card = box.closest('.ProductItem');
    if (event.relatedTarget && card.contains(event.relatedTarget)) return;
    box.classList.remove('is-hovering', 'is-hover-suppressed');
  }

  function handle(event) {
    if (event.type === 'keydown' && event.key !== 'Enter' && event.key !== ' ') return;
    var arrow = event.target && event.target.closest ? event.target.closest('.PICarousel__Arrow') : null;
    if (!arrow) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    var box = arrow.closest('[data-pi-carousel]');
    if (!box) return;
    var requested = box.getAttribute('data-requested');
    var current = parseInt(requested || box.getAttribute('data-current') || '0', 10);
    if (requested === null && box.classList.contains('is-hovering') && box.classList.contains('is-hover-ready') && !box.classList.contains('is-hover-suppressed')) {
      var hoverImage = box.querySelector('[data-pi-hover-src]');
      var hoverId = hoverImage ? hoverImage.getAttribute('data-media-id') : null;
      box.querySelectorAll('.PICarousel__Slide').forEach(function (slide, index) {
        if (hoverId && slide.getAttribute('data-media-id') === hoverId) current = index;
      });
    }
    show(box, current + (arrow.classList.contains('PICarousel__Arrow--next') ? 1 : -1));
  }

  var observer = window.IntersectionObserver ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      loadHover(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '150px' }) : null;

  function init(root) {
    if (!finePointer.matches || !observer) return;
    root.querySelectorAll('[data-pi-carousel]').forEach(function (box) {
      if (box._piObserved || !box.querySelector('[data-pi-hover-src]')) return;
      box._piObserved = true;
      observer.observe(box);
    });
  }

  document.addEventListener('pointerover', enter);
  document.addEventListener('pointerout', leave);
  document.addEventListener('click', handle, true);
  document.addEventListener('keydown', handle, true);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  finePointer.addEventListener('change', function () {
    if (finePointer.matches) init(document);
    else document.querySelectorAll('.is-hovering').forEach(function (box) { box.classList.remove('is-hovering'); });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
